/**
 * Jobs filter with REST API
 * Native JS only - no jQuery
 */
function vzRestJobsFilter() {
  const jobsList = document.querySelector("ul.vz-jobs-list");
  const filterContainer = document.querySelector(".vz-jobs-filter");

  if (!jobsList || !filterContainer) return;

  const restEndpoint = `${vz_ajax.resturl}vertriebszeitung/v1/jobs`;
  let isLoading = false;

  const fetchNewList = function (location) {
    if (isLoading) return;

    isLoading = true;
    jobsList.classList.add('loading');

    const url = new URL(restEndpoint);
    if (location) {
      url.searchParams.set('location', location);
    }

    fetch(url, {
      method: 'GET',
      headers: {
        'X-WP-Nonce': vz_ajax.rest_nonce,
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(content => {
      if (content && content.html) {
        jobsList.innerHTML = content.html;
        if (typeof equalizePostThumbnails === 'function') {
          equalizePostThumbnails();
        }
      }
    })
    .catch(error => {
      console.error('Jobs filter failed:', error);
    })
    .finally(() => {
      isLoading = false;
      jobsList.classList.remove('loading');
    });
  };

  // Event delegation: single handler on parent instead of N handlers
  filterContainer.addEventListener("click", function(event) {
    const button = event.target.closest('.js-filter-jobs');
    if (!button) return;

    const newLocation = button.getAttribute("data-loc");
    const wasActive = button.classList.contains("active");

    // Remove active class from all buttons
    const allButtons = filterContainer.querySelectorAll('.js-filter-jobs');
    allButtons.forEach((element) => element.classList.remove("active"));

    if (!wasActive) {
      fetchNewList(newLocation);
      button.classList.add("active");
    } else {
      fetchNewList('');
    }
  });
}
